import { TOptions } from "i18next";
import { useTranslation } from "react-i18next";

export type UserManagementResource = "users" | "attendants";

export function useUserManagementTranslation(resource: UserManagementResource) {
  const { t, i18n } = useTranslation();

  return {
    i18n,
    t: (key: string, options?: TOptions) => t([
      key.replace("translations.admin.users", `translations.admin.${resource}`),
      key,
    ], options),
  };
}
